@if (isMobile) {
  <div class="mobileLogoWrapper">
    <img class="logo" src="/assets/svg/logo-color-with-text.svg" />
  </div>
}

<div class="wrapper">
  <div class="wrapperChild">
    <header>
      <ng-content> </ng-content>
      @if (success) {
        <img src="/assets/svg/success.svg" />
      }
      <ng-content select="h2"> </ng-content>
    </header>

    <section class="text">
      <ng-content select="p"> </ng-content>
    </section>

    <section class="form">
      <ng-content select="form"> </ng-content>
    </section>

    @if (success || failure) {
      <section>
        @if (!isMobile && !goToApp && isRegistered === undefined) {
          <a
            normal-link
            (click)="goToLogin()"
            >{{ 'sign_in' | translate }}</a
            >
          }
          @if (!isMobile && !goToApp && isRegistered === false) {
            <a
              normal-link
              (click)="goToRegister()"
              >{{ 'sign_in_to_complete' | translate }}</a
              >
            }
            @if (!isMobile && !goToApp && isRegistered === true) {
              <a normal-link (click)="goToLogin()">{{
                'login_to_complete' | translate
              }}</a>
            }
            @if (isMobile) {
              <a href="https://www.goodloading.com/en/blog/">{{
                'go_to_blog' | translate
              }}</a>
            }
            @if (goToApp) {
              <a normal-link (click)="goToHomepage()">{{ 'go_to_app' | translate }}</a>
            }
          </section>
        }
      </div>
    </div>
